import { faPrescriptionBottleMedical } from '@fortawesome/pro-regular-svg-icons/faPrescriptionBottleMedical'
import type { TrackingSources } from '@lib/tracking/TrackingSources'
import { getBackgroundGradient } from '@lib/utilities/getBackgroundGradient'
import type { TreatmentTopicForRelatedTreatmentPageProps } from '@modules/drugs/helpers/getRelatedTreatmentTopics'
import { TreatmentTopicCardCarousel } from '../TreatmentTopicCardCarousel'

interface RelatedTreatmentTopicLinksProps {
  relatedTreatmentTopics: TreatmentTopicForRelatedTreatmentPageProps
  trackingSource: TrackingSources
}

/**
 * Render a list of links to treatment topics from the Graphite Interlinking API as treatment topic cards.
 *
 * @param relatedTreatmentTopics List of treatment topics to display
 */
export default function RelatedTreatmentTopicLinks({
  relatedTreatmentTopics,
  trackingSource,
}: RelatedTreatmentTopicLinksProps) {
  const relatedTreatmentTopicCards = (relatedTreatmentTopics ?? []).map(
    (treatmentTopic, index) => {
      return {
        backgroundGradient: getBackgroundGradient(index + 4), // Shift the gradient modulo
        description: treatmentTopic.primaryTitle,
        slug: treatmentTopic.slug,
        subtitle: (treatmentTopic.metaTitle.split('[')[0] ?? '').trim(), // FIXME: Clean up
      }
    },
  )

  if (relatedTreatmentTopicCards.length < 1) {
    return null
  }

  return (
    <section id='related-treatment-topics'>
      <TreatmentTopicCardCarousel
        cards={relatedTreatmentTopicCards}
        icon={faPrescriptionBottleMedical}
        subheading='Learn More About These Treatments'
        trackingSource={trackingSource}
      />
    </section>
  )
}
